import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageView, syncSessionRecordingForPath } from '../../lib/analytics/posthog';
import { isInviteSignPath } from '../../lib/signLink';

const PostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = isInviteSignPath(location.pathname) ? '/s' : location.pathname;
    const search = isInviteSignPath(location.pathname) ? '' : location.search;
    syncSessionRecordingForPath(pathname);
    capturePageView(pathname, search);
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogPageView;
